import React, { useState, useEffect } from "react";
import logo from "../../images/logo.png";
import HeaderContracts from "../HeaderContracts";

import { useParams } from "react-router-dom";
import ContractDisplay from "../ContractDisplay/index";

import css from "../ContractPage/ContractPage.module.css";

function ContractPage() {
  const [contract, setContract] = useState();
  const { id } = useParams();
  console.log("rendered!");
  useEffect(() => {
    console.log({ id });
  }, []);
  return (
    <div className={css.gridContainer}>
      <div className={css.header}>
        <img className={css.Applogo} src={logo} alt="logo" />
        <link
          href="https://fonts.googleapis.com/css?family=Montserrat&display=swap"
          rel="stylesheet"
        ></link>

        <HeaderContracts />
        <ContractDisplay contract={contract} />
        <p>test</p>
      </div>
    </div>
  );
}

// let searchFields = [{"contract_id",
// "contract_name",
// "ukprn",
// "start_date",
// "end_date",
// "num_learners",
// "skill_level",
// "document",
// "summary",
// "date_added",
// "finance_sign_off",
// "finance_sign_off_name",
// "management_sign_off",
// "management_sign_off_name",
// "legal_sign_off",
// "legal_sign_off_name",
// "comments";}]

ContractPage.defaultProps = [
  {
    contract_id: 1,
    contract_name: "School of Code",
    ukprn: 12345,
    start_date: "2020-01-20",
    end_date: "2020-05-14",
    num_learners: 24,
    skill_level: "4",
    document: null,
    summary: "a wicked course for learning tech skills",
    date_added: "2020-02-10",
    finance_sign_off: false,
    finance_sign_off_name: null,
    management_sign_off: true,
    management_sign_off_name: "H Kent",
    legal_sign_off: false,
    legal_sign_off_name: null,
    comments: ["looks good - H Kent"]
  },
  {
    contract_id: 2,
    contract_name: "School of Toad",
    ukprn: 54321,
    start_date: "2020-06-20",
    end_date: "2020-08-14",
    num_learners: 21,
    skill_level: "HND4",
    document: null,
    summary: "a wicked course for learning toad skills",
    date_added: "2020-02-10",
    finance_sign_off: true,
    finance_sign_off_name: "S Dent",
    management_sign_off: true,
    management_sign_off_name: "H Kent",
    legal_sign_off: false,
    legal_sign_off_name: null,
    comments: []
  }
];

export default ContractPage;
